import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function CaretUpIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      height="1em"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0.668762L10 9.33126L0 9.33126L5 0.668762Z"
        fill={"currentColor"}
      />
    </svg>
  );
};
